<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="处理人" prop="applyUserName">
              <el-input
                v-model="searchForm.applyUserName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="处理时间"
              prop="updatedTime"
            >
              <q-date-picker startFiled="createdTimeStart" endFiled="createdTimeEnd" v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="applyUserName" label="处理人" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdTime" label="处理时间" align="center"></el-table-column>
          <el-table-column prop="orderCount" label="订单数量" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="totalAmount" label="合计金额" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="successNumber" label="成功数" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="failNumber" label="失败数" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column  class-name="action-column"  label="操作" align="center">
            <template v-slot="scope">
              <el-button type="text" size="small" @click="handleDetail(scope.row)">
                查看明细
              </el-button>
              <el-button 
                v-if="scope.row.orderCount !== scope.row.successNumber" 
                type="text" 
                size="small" 
                @click="tautology(scope.row)"
              >
                重试
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        applyUserName: '',
        createdTimeStart: '',
        createdTimeEnd: ''
      },
      panelData: {},
      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
    };
  },
  methods: {
    init() {
      // this.getList();
      this.onSearch()
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport.queryBatchVerificationLogList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.createdTimeStart = ''
      this.searchForm.createdTimeEnd = ''
      this.$refs.dateRef.reset()
    },
    handleDetail(row) {
      const { batchVerificationId } = row
      this.openSubPage({
        path: 'writeoff-detail',
        query: { batchVerificationId }
      })
    },
    tautology(row) {
      this.loading = true;
      this.$api.dataReport.batchVerificationRetry(row.batchVerificationId)
        .then(res => {
          if (res.success) {
            this.$message.success("操作成功");
            this.init();
          }
        }).finally(() => {
          this.loading = false;
        });
    }
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}
  .tips {
    margin-top: 10px;
  }

</style>
